/* eslint-disable no-template-curly-in-string */
import 'react-phone-input-2/lib/style.css';
import React, { useState } from 'react';
import 'react-phone-input-2/lib/style.css'
import PropTypes from 'prop-types';
import { Form, withFormik } from 'formik';
import * as Yup from 'yup';
import { Image } from '../Image';
import { industries, Regex } from '../../shared/helpers';
import api from '../../api';
import {
  AvatarChooser,
  Dropdown as FormDropdown,
  Input as FormInput,
} from '../Form';
import { withDropdownClassNames, withInputClassNames } from './HOC';
import './EditProfile.css';
import classNames from 'classnames';
import PhoneInput from 'react-phone-input-2';

const Input = withInputClassNames(FormInput);
const Dropdown = withDropdownClassNames(FormDropdown);

const EditProfile = ({
  type,
  values,
  isSubmitting,
  dirty,
  handleEditProfile,
  usaStates,
}) => {
  const dropDownExtraProps = {};
  const [dirtyForm, changeDirtyHandler] = useState(false);

  if (values.country === values.country) {
    dropDownExtraProps.options = usaStates;
  } else {
    dropDownExtraProps.search = query => api.fetchStates(query, values.country);
  }

  const industryOptions = industries.map(industry => ({
    key: industry,
    text: industry,
    value: industry,
  }));

  [values.first_name, values.last_name] = values.name.split(' ');
  // let phone_number_with_code = values.phone_number.split(' ');

  // if (!values.countryCode && !values.phone) {
  //   if (phone_number_with_code.length > 1) {
  //     [values.countryCode, values.phone] = phone_number_with_code;
  //   } else {
  //     [values.countryCode, values.phone] = ["61", phone_number_with_code[0]];
  //   }
  // }

  return (
    <div className="container">
      <div className="row">
        <Form autoComplete="off">
          {['Client', 'Manager', 'Master'].includes(type) && (
            <div className="col-12 col-lg-9 mx-auto">
              <div className="bg-white shadow-card mt-20">
                <div className="row client-form">
                  <div className="col-12">
                    <div className="edit-profile-header modal-header py-4 px-5 d-flex align-items-center align-items-md-start">
                      <p className="t-16 t-md-21 m-0">
                        {' '}
                        Account Details/Company Details
                      </p>
                      <div className="row">
                        <button
                          className={`btn t-10 t-md-15 rounded ${
                            (dirty || dirtyForm) && !isSubmitting
                              ? 'btn-primary'
                              : 'btn-outline-gray-light'
                          }`}
                          type="submit"
                          disabled={(!dirty && !dirtyForm) || isSubmitting}
                        >
                          Save
                        </button>
                        <button
                          className="btn ml-3 t-10 t-md-15 rounded btn-back"
                          onClick={() => window.history.back()}
                          type="reset"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 px-5">
                    <div className="col p-0">
                      <hr className="m-0" />
                    </div>
                  </div>
                  <div className="edit-profile-body col-12 p-5 pt-0">
                    <div className="row">
                      <div className="col-12 col-lg-4 avatar">
                        <AvatarChooser
                          name="avatar_url"
                          extraClassName="profile-avatar-edit"
                          label={
                            values.picture || values.avatar_url
                              ? 'Edit Photo'
                              : 'Add Photo'
                          }
                          alt="Profile Picture"
                          pictureClassName={`edit-profile__content-profile-pic profile-avatar-edit ${values.picture &&
                            'edit-profile__content-profile-pic-with-border'} background ${
                            values.avatar_url ? 'edit' : 'add'
                          }`}
                          labelClassName="edit-profile__content-profile-pic-label"
                        />
                      </div>
                      <div className="col-8">
                        <div className="col-9 col-md px-0">
                          <div className="row">
                            <div className="col-6 w-100">
                              <Input
                                oldStyle={false}
                                hasInput={!!values.first_name}
                                label="First Name"
                                name="first_name"
                                onChange={e => {
                                  values.name = `${e.target.value} ${
                                    values.last_name
                                  }`;
                                  changeDirtyHandler(true);
                                }}
                              />
                            </div>
                            <div className="col-6">
                              <Input
                                label="Last Name"
                                name="last_name"
                                oldStyle={false}
                                hasInput={!!values.last_name}
                                onChange={e => {
                                  values.name = `${values.first_name} ${
                                    e.target.value
                                  }`;
                                  changeDirtyHandler(true);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="form-row">
                          <Input
                            label="Email"
                            name="email"
                            type="email"
                            oldStyle={false}
                            hasInput={!!values.email}
                          />
                        </div>
                        <div className="form-row phoneContainer">
                          <PhoneInput
                            country={'us'}
                            enableAreaCodes={true}
                            countryCodeEditable={true}
                            value={values.phone_number}
                            onChange={phone => {
                              values.phone_number = phone;
                              changeDirtyHandler(true);
                            }}
                          />
                        </div>

                        <div className="form-row">
                          <div className="col-9 col-md mb-0 px-0">
                            <div className="row">
                              <div className="col-6 mb-3 w-100">
                                <Dropdown
                                  extraClassName="additional-dropdown"
                                  fluid
                                  enableSearch
                                  oldStyle={false}
                                  label="Country"
                                  search={api.fetchCountries}
                                  noResultsMessage="No countries found."
                                  name="country"
                                  hasInput={!!values.country}
                                  placeholder="Select a Country"
                                  onChange={(field, form) => {
                                    form.setFieldValue('state', '');
                                  }}
                                />
                              </div>
                              <div className="col-6 mb-3">
                                <Dropdown
                                  {...dropDownExtraProps}
                                  extraClassName="additional-dropdown"
                                  fluid
                                  oldStyle={false}
                                  label="State"
                                  enableSearch
                                  hasInput={!!values.state}
                                  noResultsMessage="No states found."
                                  name="state"
                                  placeholder="Select a State"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form-row dropdown-industry">
                          <div className="col-9 col-md mb-0 px-0">
                            <div className="row">
                              <div className="col-12">
                                <Dropdown
                                  label="Industry"
                                  oldStyle={false}
                                  hasInput={!!values.industry_type}
                                  extraClassName="additional-dropdown"
                                  fluid
                                  placeholder="Select a Industry"
                                  selection
                                  name="industry_type"
                                  options={industryOptions}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form-row">
                          <Input
                            label="Company name "
                            name="company_name"
                            oldStyle={false}
                            hasInput={!!values.company_name}
                            required
                          />
                        </div>
                        <div className="form-row">
                          <div className="col mb-0">
                            <p
                              className="t-13 text-primary cursor-pointer"
                              onClick={handleEditProfile}
                            >
                              Edit Password
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {type === 'Freelancer' && (
            <div className="col-12 col-lg-7 mx-auto">
              <div className="bg-white shadow-card mt-14">
                <div className="row freelancer-form">
                  <div className="col-12">
                    <div className="edit-profile-header modal-header py-4 px-5 d-flex align-items-center align-items-md-start">
                      <p className="t-16 t-md-21 m-0">Account Details</p>
                      <button
                        className={`btn ml-auto px-md-8 t-10 t-md-15 rounded text-uppercase ${
                          dirty && !isSubmitting
                            ? 'btn-primary'
                            : 'btn-outline-gray-light'
                        }`}
                        type="submit"
                        disabled={!dirty || isSubmitting}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  <div className="edit-profile-body col-12 p-5 pt-0">
                    <div className="row">
                      <div className="col-12 col-md">
                        <div className="row">
                          <Input label="Name" name="name" />
                        </div>
                        <div className="row">
                          <Input label="Email" name="email" type="email" />
                        </div>
                        <div className="row">
                          <div className="col mt-3 mt-md-10 mb-0">
                            <p
                              className="t-13 text-primary cursor-pointer"
                              onClick={handleEditProfile}
                            >
                              Edit Password
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md">
                        <div className="row">
                          <Input
                            label="Phone Number"
                            type="number"
                            name="phone_number"
                            type="phoneNumber"
                            placeholder="555-555-5555"
                          />
                        </div>
                        <div className="row">
                          <div className="col mb-0">
                            <Dropdown
                              extraClassName="additional-dropdown"
                              fluid
                              enableSearch
                              search={api.fetchCountries}
                              noResultsMessage="No countries found."
                              name="Country"
                              placeholder="Select a Country"
                              onChange={(field, form) => {
                                form.setFieldValue('state', '');
                              }}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col mb-0">
                            <Dropdown
                              {...dropDownExtraProps}
                              extraClassName="additional-dropdown"
                              fluid
                              enableSearch
                              allowAdditions={false}
                              noResultsMessage="No states found."
                              name="state"
                              placeholder="Select a State"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Form>
      </div>
    </div>
  );
};

EditProfile.propTypes = {
  type: PropTypes.string,
  values: PropTypes.object,
  isSubmitting: PropTypes.bool,
  dirty: PropTypes.bool,
  handleEditProfile: PropTypes.func,
  usaStates: PropTypes.any,
};

const EditProfileForm = withFormik({
  handleSubmit: (values, { props, setSubmitting }) => {
    props.onSubmit && props.onSubmit(values, setSubmitting);
  },
  validateOnBlur: false,
  validateOnChange: false,
  validationSchema: Yup.object().shape({
    name: Yup.string()
      .min(4, 'Name should have at least ${min} characters')
      .required('Name is required')
      .test(
        'is-full-name',
        'Name is not a full name',
        value => value && value.match(Regex.fullName),
      ),
     phone_number: Yup.string()
      .matches(Regex.number, 'number is invalid')
     .required("Phone is required"),
    email: Yup.string()
      .email('Email is invalid')
      .required('Email is required'),
    company_website: Yup.string()
      .matches(Regex.site, 'Company website is invalid')
      .nullable(),
  }),
  displayName: 'EditProfileForm',
})(EditProfile);

export default EditProfileForm;



// WEBPACK FOOTER //
// ./src/components/EditProfile/EditProfile.js